import { IsDefined, IsIn, IsInt, IsISO8601, IsNumber, IsOptional, IsString, Length, Matches } from 'class-validator';
import { Exclude } from 'class-transformer/decorators';
import { BaseDto } from '../base.dto';
import { BankingSafeDto } from '../banking-safe/banking-safe.dto';
import { MerchantBriefDto } from '../merchant-brief.dto';
import { BankingPettyCashCategoryDto } from '../banking-petty-cash-category/banking-petty-cash-category.dto';
import { PosDeviceBriefDto } from '../pos-device-brief.dto';
import { UserBriefDto } from '../user-brief.dto';
import { validationPatterns } from '../../constants';

export class BankingPettyCashUpdateDto extends BaseDto {
  @IsDefined()
  @IsInt()
  merchantId: number;

  @IsOptional()
  @IsInt()
  bankingSafeCountHeaderId: number;

  @IsOptional()
  @IsString()
  @IsIn(['pos', 'safe'])
  transactionType: string;

  @IsOptional()
  @IsInt()
  posDeviceId: number;

  @IsOptional()
  @IsInt()
  safeId: number;

  @IsDefined()
  @IsInt()
  pettyCashCategoryId: number;

  @IsDefined()
  @IsInt()
  approvedUserId: number;

  @IsOptional()
  @IsString()
  @IsISO8601()
  day: string;

  @IsOptional()
  @IsNumber({maxDecimalPlaces: 2})
  grossAmount: number;

  @IsOptional()
  @IsNumber({maxDecimalPlaces: 2})
  vatValue: number;

  @IsOptional()
  @IsString()
  @Length(0, 255)
  @Matches(validationPatterns.noteValidation)
  description: string;

  @IsOptional()
  @IsString()
  @Length(0, 255)
  photoUrl: string;

  @Exclude()
  merchant?: MerchantBriefDto;

  @Exclude()
  posDevice?: PosDeviceBriefDto;

  @Exclude()
  safe?: BankingSafeDto;

  @Exclude()
  pettyCashCategory?: BankingPettyCashCategoryDto;

  @Exclude()
  approvedUser?: UserBriefDto;
}
